import { useContext } from 'react';
import BioContext from '../../store/bio-context';
import ThemeContext from '../../store/theme-context';
import Blogs from './Blogs';


const AllBlogs = () => {
    const profileInfo = useContext(BioContext);
    const theme = useContext(ThemeContext);
    const blogs = [...profileInfo.Blogs];
    console.log(blogs);
    return ( 
        <div style={{background: theme.currentTheme.background, color: theme.currentTheme.foreground}}>
            <h2 className="screenHeading">BLOGS</h2>
            {blogs && <Blogs blogs={blogs}/>}
        </div>
     );
}
 
export default AllBlogs;